import { AddonFeature, useAddon } from './use-addon';
import { useIsAccountInEnterpriseBillingType } from './use-enterprise';
export const useHasAccessToSkillMatrix = ()=>{
    const hasSkillMatrixAddon = useAddon(AddonFeature.SkillMatrix);
    const isAccountInEnterpriseBillingType = useIsAccountInEnterpriseBillingType();
    return isAccountInEnterpriseBillingType || hasSkillMatrixAddon;
};
